import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  DateField,
  Pagination,
  useShowController
} from 'react-admin';
import { Box, Chip } from '@mui/material';

import EmptyState from '../EmptyState';
import useStyles from './styles';
import { formatPlanType } from '../../constants';

const SubscriptionHistoryTab = props => {
  const { record, basePath } = useShowController(props);
  const classes = useStyles();
  if (!record) return null;

  return (
    <Box>
      <List
        hasCreate={false}
        hasEdit={false}
        hasShow={false}
        hasList={false}
        resource="subscriptionHistory"
        basePath={basePath}
        filter={{ userId: record.id }}
        empty={<EmptyState message="Subscription түүх байхгүй байна" />}
        perPage={25}
        pagination={<Pagination />}
        bulkActionButtons={false}
        sort={{ field: 'startDate', order: 'DESC' }}
        actions={false}
        exporter={false}
      >
        <Datagrid className={classes.watchHistoryTable}>
          <TextField source="id" label="ID" />
          <FunctionField 
            source="planType" 
            label="Төлөвийн төрөл" 
            render={record => (
              <Chip 
                label={formatPlanType(record.planType)} 
                size="small"
                style={{ backgroundColor: '#e3f2fd', color: '#0277bd', fontWeight: 'bold' }}
              />
            )} 
          />
          <FunctionField 
            source="status" 
            label="Төлөв" 
            render={record => {
              const status = record.status?.toLowerCase();
              let chipStyle = { fontWeight: 'bold' };
              if (status === 'active') {
                chipStyle = { backgroundColor: '#e8f5e9', color: '#2e7d32', fontWeight: 'bold' };
              } else if (status === 'expired' || status === 'cancelled') {
                chipStyle = { backgroundColor: '#ffebee', color: '#c62828', fontWeight: 'bold' };
              } else if (status === 'pending') {
                chipStyle = { backgroundColor: '#fff8e1', color: '#ff8f00', fontWeight: 'bold' };
              }
              return (
                <Chip 
                  label={record.status} 
                  size="small"
                  style={chipStyle}
                />
              );
            }}
          />
          <DateField source="startDate" label="Эхлэх огноо" showTime />
          <DateField source="endDate" label="Дуусах огноо" showTime />
        </Datagrid>
      </List>
    </Box>
  );
};

export default SubscriptionHistoryTab; 